export const REQUEST_CREATE_STREAM = 'REQUEST_CREATE_STREAM'
export const RECEIVE_CREATE_STREAM = 'RECEIVE_CREATE_STREAM'

const requestCreateStream = () => ({
  type: REQUEST_CREATE_STREAM
})

const receiveCreateStream = (streamId, streamData) => ({
  type: RECEIVE_CREATE_STREAM,
  streamId,
  streamData: {
    ...streamData,
    avatarBytes: streamData.avatarPreview.slice(23)
  }
})

export const fetchCreateStream = streamData => dispatch => {
  dispatch(requestCreateStream())

  return fetch(process.env.REACT_APP_BASE_URL + '/MyEvents/create_event',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      },
      body: JSON.stringify(streamData)
    })
    .then(
      response => response.json(),
      error => console.error('Create stream fetching error', error)
    ).then(
      json => dispatch(receiveCreateStream(json, streamData))
    )
}
